/** 初始化与身份建立分别记录，后续缺失不得回到首次绑定阶段。 */
export interface SensorsReadiness {
  initialized: boolean;
  established: boolean;
}
/** 按真实窗口保存初始化标记，避免身份工具与门控模块互相导入。 */
export const sensorsReadiness = new WeakMap<Window, SensorsReadiness>();

/**
 * 标记本窗口神策初始化成功，只由原 Provider 成功路径调用。
 * @returns 无返回值；无入参，SSR 不创建窗口状态。
 */
export function markSensorsInitialized(): void {
  if (typeof window === 'undefined') return;
  const state = sensorsReadiness.get(window) ?? { initialized: false, established: false };
  state.initialized = true;
  sensorsReadiness.set(window, state);
}

/**
 * 读取本窗口明确初始化成功标记，不读取 cookie 或历史缓存。
 * @returns 初始化成功为 true；SSR 或尚未初始化为 false，无入参。
 */
export function hasSensorsInitialized(): boolean {
  return typeof window !== 'undefined' && sensorsReadiness.get(window)?.initialized === true;
}
